import EventsAdapter from './base';

export default class Mitigation extends EventsAdapter {
  modelNamePlural = 'mitigations';
}
